$giper_balls_catalog $mol_book2_catalog
	menu_title @ \Giper Balls
	Menu_title $mol_view
		sub /
			<= Title_text $mol_paragraph
				title <= menu_title
			<= Lives_counter $mol_view
				sub /
					<= Lives_icon $mol_icon_heart
					<= Lives_count $mol_paragraph
						title <= lives_text \5
	auto /
		<= lives_regen null
	plugins /
		<= Theme $mol_theme_auto
	placeholders /
	menu_foot /
		<= Support $mol_link_support uri \https://t.me/Dev_cmyser
		<= Lights $mol_lights_toggle
	spreads *
		lines <= Lines $giper_balls_lines
			tools /
				^
				<= Spread_close
		crowd <= Crowd $giper_balls_crowd
			tools /
				^
				<= Spread_close
		chess <= Chess $giper_balls_chess_game
			tools /
				^
				<= Spread_close
		requisites <= Requisites $giper_balls_requisites
			tools /
				^
				<= Spread_close
		offer <= Offer $giper_balls_offer
			tools /
				^
				<= Spread_close
		shop <= Shop $giper_balls_shop
			tools /
				^
				<= Spread_close
